<template>
  <div>
    <div class="navCard">
      <div class="navCard-top">
        <div class="navCard-top-l">
          <img :src="object.tp" @click="preViewImg(object.tp)"/>
        </div>
        <div class="navCard-top-r">
          <h3>{{object.name}} <img :src="imgUrl"/></h3>
          <p>{{object.sex_dictText}} | {{object.csrq}}出生 | 籍贯{{object.jg}}</p>
        </div>
      </div>
    </div>
    <div class="content_nr">
      <div v-html="object.sjms" class="h5-html"></div>
      <div class="desc">发布时间：<span class="time">{{object.createTime}}</span></div>
    </div>
     <div  class="fle-bottom">
      <div class="flex-center label">票数：<span class="ps">{{object.ps}}</span></div>
      <div v-if="hdzt!='3'" class="btn"  @click="clickTp">我要投票</div>
    </div>
  </div>
</template>

<script>
import { getAction,postAction} from '@/api/manage'
import { ImagePreview } from 'vant'
import { addRandomAndGetPreviewImageUrlsFromRichText } from '@/utils/util'
import bottomShare from '@/views/common/bottom-share.vue'
export default {
  components: { bottomShare },
  data() {
    return {
      downOption: {
        auto: false, //是否在初始化后,自动执行downCallback; 默认true
      },
      richImages:[],
      html:'',
      object:{},
      imgUrl:require("@images/hmhq/man.png"),
      params:this.$route.query,
    }
  },
  created() {
    this.hdzt=  sessionStorage.getItem('hdzt')||0;
    this.getData();
  },
  mounted() {
  },
  methods: {
    previewImage(e) {
      if (e.target.tagName == 'IMG') {
        ImagePreview({
          images: this.richImages,
          startPosition: e.target.src.split('random=')[1] - 1,
          closeOnPopstate: true, //页面回退关闭预览
        })
      }
    },
    getData() {
      let params = {id:this.params.id};
      getAction('/zhshj/dzjhdxpx/query/app',params)
      .then((res) => {
        let object = res.result.records[0];
        this.object  = object;
        this.object.sex == '120' ? this.imgUrl = require("@images/hmhq/woman.png") : ""
        this.object.tp == null ? this.object.tp = require("@images/banner/user.jpg") :""
        this.html= addRandomAndGetPreviewImageUrlsFromRichText(object.sjms)
      })
    },
    preViewImg(img){
      let arr = [img];
      ImagePreview(arr);
    },
    clickTp(){
      let params = {wltpId:this.params.tpId,bpxrId:this.params.id,czpt:'3'}
        postAction('/zhshj/tpjlb/add-app',params).then(res=>{
          if(res.success){
            this.$toast("投票成功")
           let ps = res.result;
           this.object.ps = ps;
          }else{
            this.$toast(res.message);
          }
        })
    }
    
  },
}
</script>

<style lang="less" scoped>
// 个人简介
.navCard{
  width: 100%;
  padding: 20px 20px 40px;
  box-sizing: border-box;
  background: #000000;
  background-image: url("../../assets/images/hmhq/bjk.png");
  color: white;
  &-top{
    width: 100%;
    display: flex;
    justify-content: space-between;
    &-l{
      width: 100px;
      height: 100px;
      padding: 4px;
      box-sizing: border-box;
      border-radius: 50%;
      background: white;
      display: flex;
      align-items: center;
      justify-content: center;
      img{
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }
    &-r{
      width: 65%;
      h3{
        font-size: 18px;
        padding: 8px 0px;
        margin: 0px;
        display: flex;
        align-items: center;
        img{
          width: 14px;
          margin: 2px 0px 0px 10px;
        }
      }
      p{
        margin: 0px;
        padding: 0px;
        line-height: 26px;
        font-size: 14px;
      }
    }
  }
  &-bottom{
    width: 100px;
    display: flex;
    justify-content: center;
    p{
      margin: 10px 0px 0px;
    }
  }
}

.title {
  line-height: 40px;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
}
.desc {
  color: #696969;
  margin-bottom: 12px;
}

.fbr {
  margin-right: 8px;
}

.time {
  margin-left: 8px;
}

.content {
  color: #303133;
  text-indent: 2em;
  line-height: 22px;
}

.bottom {
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  height: 60px;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 12px;
}

.image{
  max-width: 100%;
  margin-top: 12px;
}
.content_nr{
  padding: 20px 12px;
  min-height: 200px;
  background: white;
  margin: -20px 0px 0px;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  padding-bottom: 65px;
}
.fle-bottom{
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 99;
  height: 65px;
  background: #FFFFFF;
  box-shadow: 0 -2px 6px 0 #0000000f;
   display: flex;
   align-items: center;
   justify-content: space-between;
   padding: 0 15px;
   box-sizing: border-box;
  
  .label{
     color: #1a1a1a;
     font-size: 16px;
     font-weight: bold;
     display: flex;
     align-items: center;
  }
  .ps{
    color: #6193E8;
  }
  .btn{
    width: 125px;
    height: 40px;
    background: #1D6DDB;
    border-radius: 20px;
    color:#FFF; 
    text-align: center;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 40px;
  }
}
</style>
<style>
.h5-html img {
  width: 100%;
  height: auto;
  object-fit: fill;
}
</style>
